import { useMutation } from 'react-query';

import { deletePoapView as mutationFn } from 'api/endPoints/deletePoapView';

export const useMutationDeletePoapView = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

export interface QueryParams {
    viewId: number;
}
